var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, cloneElement } from 'react';
import { toArray } from 'lodash';
import classNames from 'classnames';
var useCollapse = function (props) {
    var _a;
    var _b = props.activeKey, activeKey = _b === void 0 ? [] : _b, className = props.className, _c = props.showArrow, showArrow = _c === void 0 ? true : _c, _d = props.collapseIconName, collapseIconName = _d === void 0 ? 'chevron-down' : _d, _e = props.expandIconName, expandIconName = _e === void 0 ? 'chevron-up' : _e;
    var _f = useState(activeKey), expandedList = _f[0], setExpandedList = _f[1];
    var handleClickItem = function (key) {
        var updatedList = [];
        if (expandedList.includes(key)) {
            updatedList = expandedList.filter(function (item) { return item !== key; });
        }
        else {
            updatedList = __spreadArray(__spreadArray([], expandedList, true), [key], false);
        }
        setExpandedList(updatedList);
    };
    var getItems = function () {
        var children = props.children;
        return toArray(children).map(function (child) {
            var _a;
            var childProps = __assign(__assign({}, child.props), { onClickItem: handleClickItem, isCollapse: !expandedList.includes((_a = child.props) === null || _a === void 0 ? void 0 : _a.labelKey), showArrow: showArrow, collapseIconName: collapseIconName, expandIconName: expandIconName });
            return cloneElement(child, childProps);
        });
    };
    var collapseClassName = classNames('c-els-accordion', 'c-els-accordion--icon-right', 'c-collapse', (_a = {}, _a[className] = className, _a));
    return {
        expandedList: expandedList,
        handleClickItem: handleClickItem,
        getItems: getItems,
        collapseClassName: collapseClassName
    };
};
export default useCollapse;
